export default __webpack_public_path__ + "static/media/product-app-1.1c9c8a85.png";